import { computed, defineComponent } from "vue";
import { useVuePublicRouteData } from "@logscord/public-site/adapters/vue";
import { PublicArticleDirectoryResponseSchema } from "@logscord/public-site-config";
import {
    PublicFooter,
    PublicNavbar,
    usePublicLocalizedPath,
} from "./PublicShell.js";
import { useLocale } from "../../locales/i18n.js";


//////////////////////////////////////////////////
//  DOCS INDEX
//////////////////////////////////////////////////


export default defineComponent({
    setup() {
        const { i18n } = useLocale();
        const publicPath = usePublicLocalizedPath();
        const publicRouteData = useVuePublicRouteData();
        const directory = computed(() => {
            const value = publicRouteData.getData("publicArticles");
            const result = PublicArticleDirectoryResponseSchema.safeParse(value);

            return result.success
                ? result.data
                : null;
        });
        const loading = computed(() => (
            publicRouteData.state.value?.status === "loading"
            || publicRouteData.state.value?.status === "idle"
        ));
        const unavailable = computed(() => {
            const status = publicRouteData.state.value?.status;

            return status === "unavailable"
                || (status === "ready" && directory.value === null);
        });

        return () => (
            <div class="public-page">
                <PublicNavbar />

                <div class="public-hero">
                    <span class="landing-kicker">{i18n("docs.hero.kicker")}</span>
                    <h1>{i18n("docs.hero.title")}</h1>
                    <p>{i18n("docs.hero.description")}</p>
                </div>

                <div class="manual-grid manual-blog-grid">
                    {loading.value && <div class="manual-card manual-blog-card" />}
                    {unavailable.value && (
                        <div class="manual-card public-doc-unavailable-card" role="status">
                            <div class="manual-card-icon public-doc-unavailable-icon">
                                <i class="material-symbols-outlined">cloud_off</i>
                            </div>

                            <div>
                                <h2>{i18n("docs.unavailable.title")}</h2>
                                <p>{i18n("docs.unavailable.description")}</p>
                            </div>
                        </div>
                    )}

                    {directory.value?.articles.map((article) => (
                        <router-link class="manual-card manual-blog-card" to={publicPath(`/docs/${article.slug}`)}>
                            <div class="manual-card-icon">
                                <i class="material-symbols-outlined">{article.icon}</i>
                            </div>

                            <span class="manual-blog-category">{article.category} · {article.readTime}</span>
                            <h2>{article.title}</h2>
                            <p>{article.description}</p>

                            <div class="manual-blog-link">
                                {i18n("docs.read_manual")}
                                <i class="material-symbols-outlined">arrow_forward</i>
                            </div>
                        </router-link>
                    ))}
                </div>

                <PublicFooter />
            </div>
        );
    },
});
